import { render, staticRenderFns } from "./DashFeesList.vue?vue&type=template&id=4f6575a1&scoped=true&"
import script from "./DashFeesList.vue?vue&type=script&lang=js&"
export * from "./DashFeesList.vue?vue&type=script&lang=js&"
import style0 from "./DashFeesList.vue?vue&type=style&index=0&id=4f6575a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6575a1",
  null
  
)

export default component.exports